import { Helmet } from "react-helmet";
import React from "react";
import { useState, useEffect, useContext } from "react";
import sendRequest from "hooks/useAxios";
import "components/blog/blog.css";
import Blogknowable from "components/blog/BlogKnowable";
import BlogVideo from "components/blog/BlogVideo";
import GroupView from "common/Group-View/GroupViewItem";
import GroupViewContainer from "common/Group-View/GroupViewContainer";
import Blog from "common/blog/Blog";
import { pageSectionId } from "constants/constants";
import { translateToReactSelect } from "../utils/helperFunctions";
import Loader from "utils/Loader.jsx";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import AddArticleModalData from "../components/blog/AddArticleModal.jsx";
export default function Blog1() {
  const auth = useContext(WithAuthentication);
  const [blognews, setBlognews] = useState([
    {
      title: "داغ ترین تکنولوژی",
      item: [
        {
          title: "قوی ترین لپ تاپ مهندسی جهان",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "کارت های اعتباری مجهز به حسگر اثر انگشت",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "آموزش نصب ویندوز 11",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "قوی ترین لپ تاپ مهندسی جهان",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        }
      ],
      type: 1,
      id: 5,
      numberOf: 4,
      Color: "rgb(32, 59, 140)",
      moreText: "مطالب بیشتر",
      Component: Blog,
      idConfig: pageSectionId.blogFirstBlog
    },
    {
      title: "آخرین مطالب",
      item: [
        {
          title: "قوی ترین لپ تاپ مهندسی جهان",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "کارت های اعتباری مجهز به حسگر اثر انگشت",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "آموزش نصب ویندوز 11",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "قوی ترین لپ تاپ مهندسی جهان",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        }
      ],
      type: 1,
      id: 6,
      numberOf: 4,
      Color: "rgb(32, 59, 140)",
      moreText: "مطالب بیشتر",
      Component: Blog,
      idConfig: pageSectionId.blogSecondBlog
    },
    {
      title: "اخبار",
      item: [
        {
          title: "قوی ترین لپ تاپ مهندسی جهان",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "کارت های اعتباری مجهز به حسگر اثر انگشت",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "آموزش نصب ویندوز 11",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        },
        {
          title: "قوی ترین لپ تاپ مهندسی جهان",
          description:
            "لپ تاپ های ایستگاه کاری در حقیقت لپ تاپ با کارایی بسیار بالا هستند که ظاهر ساده و مینیمال دارند.",
          date: "1401/1/1",
          writer: "امین تقوی نیا",
          link: ""
        }
      ],
      type: 1,
      id: 7,
      numberOf: 4,
      Color: "rgb(32, 59, 140)",
      moreText: "مطالب بیشتر",
      Component: Blog,
      idConfig: pageSectionId.blogThirdBlog
    }
  ]);
  const [blogHashtags, setBlogHashtags] = useState([]);
  const [postList, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    async function pageLoad() {
      await sendRequest("gethashtag", { hashtagType: 1 }).then(({ data }) => {
        setBlogHashtags(translateToReactSelect(data.hashtags, false));
      });
      await sendRequest("getlistofpost").then(({ data }) => {
        setPostList(data.postList);
      });
      setIsLoading(false);
    }
    pageLoad();
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>بلاگ</title>
      </Helmet>
      {isLoading && <Loader />}
      <BlogVideo postList={postList}></BlogVideo>
      {auth.userInfo.userType == 0 && (
        <div className="m-2">
          <button
            className="btn btn-success p-2 mx-2"
            data-bs-toggle="modal"
            data-bs-target="#addArticleModal"
          >
            افزودن مطلب
          </button>
          <AddArticleModalData></AddArticleModalData>
        </div>
      )}
      <GroupViewContainer GroupViewData={blognews} />
      {/* {postList.map((value, index) => {
        return (
          <GroupView
            Component={Blog}
            // numberOf={value.item.length}
            // id={index}
            items={postList}
            idConfig={Object.values(pageSectionId)[index + 2]}
            // title={title}
            type={1}
            moreText="مطالب بیشتر"
            blogHashtags={blogHashtags}
          ></GroupView>
        );
      })} */}
      <Blogknowable blogHashtags={blogHashtags} page="blog"></Blogknowable>
    </div>
  );
}
